var pageTab = {
  //注册点击事件
  regEvent: function () {
    var _this = this;
    //点击tab触发
    $('.category-list>li').on('click', function () {
      // console.log(this.classList[0])
      // tab-all
      var cateName = this.classList[0].substr(4);
      _this.changTabPage(this, cateName);
    });

    //点击标签触发 是跳链接不是切tab注释掉
    // $('.category-label').on('click', function () {
    //   $('html,body').animate({scrollTop: '0px'}, 800);
    //   var cateName = this.classList[1].substr(6);
    //   _this.changTabPage($('.tab-' + cateName), cateName);
    // });

    //新的tab
    $('.category-tab-box>.list>li').on('click', function () {
      var cateName = this.classList[0].substr(4);
      _this.changTabPage(this, cateName);
    });
  },

  //切换tab页面 obj:要切换到的tab jq元素 cateName:tab名称
  changTabPage:function(obj, cateName){
    var _this = this;
    $('.content-seld').hide();
    $('.content-' + cateName).show().addClass('content-seld');
    // initMas($('.content-' + cateName)); //初始化瀑布流
    // msLoader.setLoad(); //切换页面后设置下loader状态，避免出现已加载完毕的情况
    window.cateData.pageTab = cateName;
    msnObj.layout(cateName);
    _this.setTab(obj); //设置选中状态
  },

  //设置选中状态
  setTab: function (ele) {
    $('.category-hover').removeClass('category-hover');
    $(ele).addClass('category-hover');

    //新的tab
    $('.category-tab-box>.list>.sed').removeClass('sed');
    $(ele).addClass('sed');

    var indicatorWidth = 15; //指示器宽度
    var indicatorOffset = 0; //指示器偏移量
    var x = $(ele).position().left; //li的位置
    var w = $(ele).outerWidth(true); //li的宽度
    indicatorWidth = w / 3;
    indicatorOffset = x + ((w - indicatorWidth) / 2);
    $('.indicator').css({"left": indicatorOffset, "width": indicatorWidth});
  },

  //点击向下箭头展开更多
  showAll: function(){
    $('.bt-show-all').on('click', function () {
      $('.category-tab-box > .list').toggleClass('max-h');
      $('.category-tab-box > .bt-show-all > .icon').toggleClass('arrow-turn');

    });
  },

  init: function(){
    this.regEvent();
    this.showAll();
    // initMasNew('.content'); //初始化瀑布流
  },
};

pageTab.init();